jQuery(document).ready(function($){
    if ($('[data-slider]').length) {
        $('[data-slider]').each(function() {
            let slider_opts = {
                dots: false,
                speed: 300,
                infinite: true,
                autoplay: false,
                fade: false,
                autoplaySpeed: 5000,
                cssEase: 'ease-out',
                arrows: true,
                prevArrow: '<button type="button" class="slick-prev"><i class="icon-chevron-left"></i></button>',
                nextArrow: '<button type="button" class="slick-next"><i class="icon-chevron-right"></i></button>',
            };

            let slider_style = $(this).data('slider-style') || 'medium';

            if (slider_style === 'medium') {
                slider_opts.slidesToShow = 2;

                slider_opts.responsive = [
                    {
                        breakpoint: 640,
                        settings: {
                            slidesToShow: 1,
                        }
                    },
                ];
            } else if (slider_style === 'thin') {
                slider_opts.slidesToShow = 4;

                slider_opts.responsive = [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 900,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 580,
                        settings: {
                            slidesToShow: 1,
                        }
                    },
                ];
            } else if (slider_style === 'variable') {
                slider_opts.dots = false;
                slider_opts.arrows = false;
                slider_opts.infinite = false;
                slider_opts.variableWidth = true;
                slider_opts.swipeToSlide = true;
                slider_opts.outerEdgeLimit = true;
                slider_opts.responsive = false;
                slider_opts.speed = 4500;
                slider_opts.autoplay = true;
                slider_opts.autoplaySpeed = 0;
                slider_opts.cssEase = 'linear';
                slider_opts.slidesToShow = 1;
                slider_opts.slidesToScroll = 1;
            } else if (slider_style === 'single') {
                slider_opts.slidesToShow = 1;
                slider_opts.slidesToScroll = 1;
                slider_opts.responsive = false;
                slider_opts.arrows = true;
                slider_opts.dots = true;
            }

            let $slider_parent = $(this).parents('[data-slider-parent]');

            if ($slider_parent.length) {
                let $arrows = $slider_parent.find('[data-slider-arrows]');

                if ($arrows !== undefined) {
                    slider_opts.appendArrows = $arrows;
                }

                let $dots = $slider_parent.find('[data-slider-dots]');

                if ($dots !== undefined) {
                    slider_opts.appendDots = $dots;
                }
            }

            $(this).slick(slider_opts);
        });
    }

});
